import { APPLICATION_SIDEBAR_ITEMS_IDS } from 'components/Applications/ApplicationSidebar/ApplicationSidebar';
import { JOB_SIDEBAR_ITEMS_IDS } from 'components/JobSidebar/JobSidebar';
import TourContent from 'components/Tour/TourContent/TourContent';

import { TourStep } from 'types/tour';

import { GuideType } from 'constants/enums';
import {
  APPLICATIONS,
  EDIT_JOB,
  HOME,
  JOBS,
  VIEW_APPLICATION,
  VIEW_JOB
} from 'constants/path';
import {
  TOUR_STEP_TARGET_APPLICATION_INTERVIEW_TAB,
  TOUR_STEP_TARGET_APPLICATION_OFFER_TAB,
  TOUR_STEP_TARGET_FIRST_APPLICATION_CARD_ACTION_MENU,
  TOUR_STEP_TARGET_FIRST_JOB_CARD_ACTION_MENU,
  TOUR_STEP_TARGET_GENERATE_WITH_AI_BUTTON,
  TOUR_STEP_TARGET_JOB_MATCHES_TAB,
  TOUR_STEP_TARGET_VIEW_ALL_JOBS_BUTTON
} from 'constants/tour';

export const multiPageTourSteps: TourStep[] = [
  // Home Page Steps
  {
    target: `#${TOUR_STEP_TARGET_VIEW_ALL_JOBS_BUTTON}`,
    content: (
      <TourContent
        headerKey="tour.manageJobs.header"
        subheaderKey="tour.manageJobs.subheader"
      />
    ),
    placement: 'auto',
    page: HOME,
    nextAction: 'navigate',
    targetPage: JOBS,
    disableBeacon: true
  },
  // Jobs Page Steps
  {
    target: `#${TOUR_STEP_TARGET_FIRST_JOB_CARD_ACTION_MENU}`,
    content: (
      <TourContent
        headerKey="tour.startWithJob.header"
        subheaderKey="tour.startWithJob.subheader"
      />
    ),
    placement: 'auto',
    page: JOBS,
    nextAction: 'navigate',
    targetPage: EDIT_JOB,
    disableBeacon: true
  },
  {
    target: `#${TOUR_STEP_TARGET_GENERATE_WITH_AI_BUTTON}`,
    content: (
      <TourContent
        headerKey="tour.letAIDoWork.header"
        subheaderKey="tour.letAIDoWork.subheader"
      />
    ),
    placement: 'auto',
    page: EDIT_JOB,
    nextAction: 'navigate',
    targetPage: VIEW_JOB,
    disableBeacon: true
  },
  {
    target: `#${TOUR_STEP_TARGET_JOB_MATCHES_TAB}`,
    content: (
      <TourContent
        headerKey="tour.inviteJobseeker.header"
        subheaderKey="tour.inviteJobseeker.subheader"
      />
    ),
    placement: 'auto',
    page: VIEW_JOB,
    targetTab: JOB_SIDEBAR_ITEMS_IDS.MATCHES,
    nextAction: 'navigate',
    targetPage: APPLICATIONS,
    shouldShowApplicationsButton: true,
    isFinishJobsTour: true,
    disableBeacon: true
  },
  // Applications Page Steps
  {
    target: `#${TOUR_STEP_TARGET_FIRST_APPLICATION_CARD_ACTION_MENU}`,
    content: (
      <TourContent
        headerKey="tour.manageApplications.header"
        subheaderKey="tour.manageApplications.subheader"
      />
    ),
    placement: 'auto',
    page: APPLICATIONS,
    nextAction: 'navigate',
    targetPage: VIEW_APPLICATION,
    disableBeacon: true
  },
  {
    target: `#${TOUR_STEP_TARGET_APPLICATION_INTERVIEW_TAB}`,
    content: (
      <TourContent
        headerKey="tour.scheduleInterview.header"
        subheaderKey="tour.scheduleInterview.subheader"
      />
    ),
    placement: 'auto',
    nextAction: 'navigate',
    page: VIEW_APPLICATION,
    targetTab: APPLICATION_SIDEBAR_ITEMS_IDS.INTERVIEW,
    disableBeacon: true
  },
  {
    target: `#${TOUR_STEP_TARGET_APPLICATION_OFFER_TAB}`,
    content: (
      <TourContent
        headerKey="tour.makeOffer.header"
        subheaderKey="tour.makeOffer.subheader"
      />
    ),
    placement: 'auto',
    page: VIEW_APPLICATION,
    targetTab: APPLICATION_SIDEBAR_ITEMS_IDS.OFFER,
    nextAction: 'navigate',
    targetPage: APPLICATIONS,
    isFinishApplicationsTour: true,
    disableBeacon: true
  }
];

// Separate tours for each page
export const pageSpecificTours: {
  [GuideType.Jobs]: TourStep[];
  [GuideType.Applications]: TourStep[];
} = {
  [GuideType.Jobs]: multiPageTourSteps.filter((step) =>
    step.page.startsWith(JOBS)
  ),
  [GuideType.Applications]: multiPageTourSteps.filter((step) =>
    step.page.startsWith(APPLICATIONS)
  )
};
